import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  standalone: false,
})
export class DateTimePickerComponent implements OnInit, OnChanges {
  private translate = inject(TranslateService);

  @Input() disabled = false;
  @Input() type: 'date' | 'time' | 'date-time' = 'time';
  @Input() inputDateZulu: string | null = null; // ISO-String mit Z am Ende
  @Input() hourDelay: number = 0;
  @Input() multiple: boolean = false;
  @Output() selectedDateChanged = new EventEmitter<string>();

  uniqueId: string;
  title: string;

  ngOnInit() {
    this.uniqueId = (Math.random() + 1).toString(36).substring(7);
    if (this.multiple) {
      this.title = this.translate.instant('dateTimePicker.selectDays');
    } else if (this.type == 'date') {
      this.title = this.translate.instant('dateTimePicker.selectDate');
    } else {
      this.title = this.translate.instant('dateTimePicker.selectTime');
    }
    this.ensureDefault();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputDateZulu'] && !this.inputDateZulu) {
      this.ensureDefault();
    }
  }

  private ensureDefault() {
    if (!this.inputDateZulu) {
      const today = new Date();
      today.setHours(8 + this.hourDelay, 0, 0, 0);
      this.inputDateZulu = today.toISOString();
      setTimeout(() => {
        this.selectedDateChanged.emit(this.inputDateZulu);
      });
    }
  }

  dateChanged(event: any) {
    let value = event.detail.value;
    value += 'Z';
    if (value) {
      this.inputDateZulu = value;
      this.selectedDateChanged.emit(value);
    }
  }
}
